module.exports = __webpack_public_path__ + "img/green-tick.4ee2ac0d.png";